import { createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";

declare module "@mui/material/styles" {
  interface Palette {
    tertiary: Palette["primary"];
  }

  interface PaletteOptions {
    tertiary?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    tertiary: true;
  }
}

// Create an Emotion cache with the RTL plugin
export const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const createCustomTheme = (direction: "ltr" | "rtl" = "ltr") => {
  return createTheme({
    direction,
    typography: {
      fontFamily: direction === "ltr" ?  "Figtree, Roboto, Ubuntu, sans-serif" : "Cairo",
    },
    palette: {
      primary: {
        main: "#FF8D3F",
        dark: "#FF8734",
        light: "#FF9954",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#1A1AE6",
        dark: "#0000E3",
        light: "#3333E9",
      },
      tertiary: {
        main: "#667085",
      },
      text: {
        primary: "#101828",
        secondary: "#98A2B3",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            boxShadow: "none",
          },
        },
        variants: [
          {
            props: { size: "large" }, // The button for large size
            style: {
              minHeight: "48px",
              fontSize: "16px",
            },
          },
          {
            props: { size: "medium" },
            style: {
              minHeight: "40px",
              fontSize: "15px",
            },
          },
          {
            props: { size: "small" },
            style: {
              minHeight: "32px",
              fontSize: "14px",
            },
          },
        ],
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            display: "block",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'none', // Set textTransform to "none" for Tab components
          },
        },
      },
    },
  });
};

export default createCustomTheme;
